import * as React from 'react'
import { Button } from '../../UI'

import { capitalizeFirstLetter } from '../../../lib/utils/capitalizeFirstLetter'
import CustomLink from '../../CustomLink'
import { Styled } from './styled'
import { LanguageSelect } from '../../UI/LanguageSelect'
import { useStoryblok } from '../../../lib/storyblok'
import { useI18n } from '../../../lib/context/i18n'

import { CookieBanner } from '../../../features/CookieBanner/CookieBanner'
import { CookieBannerContext } from '../../../features/CookieBanner/CookieBannerContext'

export const Footer = ({ footerData }) => {
  const data = typeof window !== 'undefined' ? useStoryblok(footerData, window.location) : useStoryblok(footerData)
  const { getTranslatedUrlFromLink } = useI18n()

  const cookieBanner = React.useContext(CookieBannerContext)

  return (
    <Styled.Footer>
      <Styled.Nav>
        {data.content.FooterNavigation?.map((group, i) => {
          return (
            <Styled.NavItem key={i}>
              <Styled.NavItemHeadline>{group.label}</Styled.NavItemHeadline>
              <Styled.NavItemList>
                {group.links.map((link, i) => {
                  return (
                    <Styled.NavItemListItem key={i}>
                      <Button
                        as={CustomLink}
                        to={getTranslatedUrlFromLink(link.link)}
                        $size="small"
                        $variant="tertiary"
                        $ignoreTheme={true}
                      >
                        {link.text}
                      </Button>
                    </Styled.NavItemListItem>
                  )
                })}
              </Styled.NavItemList>
            </Styled.NavItem>
          )
        })}
      </Styled.Nav>
      {/* TODO Create search */}
      {/* <Styled.Search>Search Placeholder</Styled.Search> */}
      <Styled.Closure>
        <Styled.ClosureNav>
          <Styled.ClosureNavItem>Copyright &copy; {new Date().getFullYear()} PDF Tools AG</Styled.ClosureNavItem>
          {data.content.FooterClosure &&
            data.content.FooterClosure.length > 0 &&
            data.content.FooterClosure[0].FooterClosureNavigation.map((link, i) => {
              return (
                <Styled.ClosureNavItem key={i}>
                  <Button
                    as={CustomLink}
                    to={getTranslatedUrlFromLink(link.link)}
                    $size="small"
                    $variant="tertiary"
                    $ignoreTheme={true}
                  >
                    {link.text}
                  </Button>
                </Styled.ClosureNavItem>
              )
            })}
          <Button $size="small" $variant="tertiary" $ignoreTheme={true} onClick={() => cookieBanner.openModal()}>
            {/* TODO: translate */}
            {'Cookie settings'}
          </Button>
          <CookieBanner />
        </Styled.ClosureNav>
        <Styled.ClosureLast>
          <Styled.ClosureLastSocials>
            {data.content.FooterSocialNavigation?.length &&
              data.content.FooterSocialNavigation?.map((social, i) => {
                if (social.show) {
                  return (
                    <Styled.ClosureLastSocialsItem key={i}>
                      <Button
                        key={social._uid}
                        as={CustomLink}
                        to={getTranslatedUrlFromLink(social.url)}
                        $size="small"
                        $variant="tertiary"
                        $ignoreTheme
                        iconLeft={`logo-${social.socialNetwork}`}
                        target="_blank"
                        title={'no-title'}
                      />
                    </Styled.ClosureLastSocialsItem>
                  )
                }
              })}
          </Styled.ClosureLastSocials>
          {/* hide language select for now */}
          <LanguageSelect />
        </Styled.ClosureLast>
      </Styled.Closure>
    </Styled.Footer>
  )
}
